import { render, staticRenderFns } from "./SendResult.vue?vue&type=template&id=477a8514&scoped=true&"
import script from "./SendResult.vue?vue&type=script&lang=js&"
export * from "./SendResult.vue?vue&type=script&lang=js&"
import style0 from "./SendResult.vue?vue&type=style&index=0&id=477a8514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a8514",
  null
  
)

export default component.exports